var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ex1"},[_c('div',{ref:"svgDiv",staticClass:"svg"})])
}
var staticRenderFns = []

export { render, staticRenderFns }